import { makeAutoObservable } from 'mobx'

class NewPaginationStore<T extends Object> {
  page: number = 0
  size: number = 100
  totalSize: number = 0
  sort: string = '-id'
  params: T
  initParams: T
  selectedRow: any = null
  scrollHeight = 0

  constructor(initParams: T, defaultSort?: string) {
    this.sort = defaultSort ?? '-id'
    this.params = initParams
    this.initParams = initParams

    makeAutoObservable(this)
  }

  setPage = (page: number) => {
    this.page = page
    this.scrollHeight = 0
    this.selectedRow = null
  }

  setSize = (size: number) => {
    if (this.page !== 0) {
      this.setPage(0)
    }
    this.size = size
  }

  setTotalSize = (total: number) => {
    this.totalSize = total
  }

  setSort = (sort: string) => {
    this.setSelectedRow(null, 0)

    const isSame = this.sort?.endsWith(sort)
    const isReverse = isSame && this.sort?.startsWith('-')

    if (isSame) {
      this.sort = isReverse ? sort?.replace(/^-+/, '') : `-${sort}`
    } else {
      this.sort = sort
    }
    if (this.page !== 0) this.setPage(0)
  }

  setParams = (params: Partial<T>, savedParams?: Array<keyof T>) => {
    Object.keys(params).forEach((key) => {
      if (params[key as keyof T] && !savedParams?.includes(key as keyof T)) {
        this.params[key as keyof T] = params[key as keyof T] as T[keyof T]
      }
    })

    Object.keys(this.params).forEach((key) => {
      if (
        this.params[key as keyof T] &&
        !savedParams?.includes(key as keyof T)
      ) {
        if (!params[key as keyof T] as T[keyof T]) {
          delete this.params[key as keyof T]
        } else {
          this.params[key as keyof T] = params[key as keyof T] as T[keyof T]
        }
      }
    })

    if (this.page !== 0) {
      this.setPage(0)
    } else {
      this.scrollHeight = 0
      this.selectedRow = null
    }
  }

  setSelectedRow = (row: any, scrollHeight: number) => {
    this.selectedRow = row
    this.scrollHeight = scrollHeight
  }

  setScrollHeight = (scrollHeight: number) => {
    this.scrollHeight = scrollHeight
  }

  resetSelectedRow = () => {
    this.selectedRow = null
    this.scrollHeight = 0
  }

  resetParams = () => {
    this.params = { ...this.initParams }
    this.page = 0
    this.size = 100
    this.totalSize = 0
    this.sort = '-id'
  }
}

export type PaginationStoreType<
  T extends Record<string, any> = Record<string, any>,
> = InstanceType<typeof NewPaginationStore<T>>

export default NewPaginationStore
